import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import { Col, Row } from "reactstrap";
import { languageService } from "../../../Language/language.service";

export const SideSubNavigationHeader = ({ value }) => {
  return (
    <div className=" side-sub-nav-header no-print">
      <h5>{value}</h5>
    </div>
  );
};

export const SelectedSideSubNavHeader = ({ value }) => {
  return (
    <div className="side-sub-nav-header no-print">
      <h5>{value ? value : "No item selected"}</h5>
    </div>
  );
};

export const TopSubNavigationList = ({ items = [], currPath = null, onClick = () => {} }) => {
  return (
    <div className="top-sub-nav-list no-print" style={{ display: "flex" }}>
      {items.map((item) => (
        <div
          onClick={(e) => {
            currPath !== item.path && onClick(item.path);
          }}
        >
          <Link key={item.id} className={`top-sub-nav-item ${currPath === item.path ? "selected" : ""}`} to={item.path}>
            {languageService(item.value)}
          </Link>
        </div>
      ))}
    </div>
  );
};

export const SideSubNavigationList = ({ items, currPath }) => {
  return (
    <div className="side-sub-nav-list location-prefix-list location-button no-print">
      {items.map((item) => (
        <SubSideNavItem key={item.id} item={item} selected={currPath === item.path} />
      ))}
    </div>
  );
};

const SubSideNavItem = ({ item, selected }) => {
  return (
    <Link className={`loc-parent  ${selected ? "selected" : ""}`} to={item.path}>
      {item.value}
    </Link>
    // <div

    //   onClick={(e) => {
    //     handleSelectedItem(item);
    //   }}
    // >
    // {item.value}
    // </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Common/SideSubNavigation/index.jsx